import { computed, ref } from 'vue';
import { IContactListItem } from '../utils/interfaces';
import { useContactListStore } from '../store/contactListStore';

const getInitialCurrentMarket = (): string | null => {
  const match = window.location.pathname.match(/\/([a-z]{2})\/([a-z]{2})\//);
    if (match) {
      return `${match[1]}/${match[2]}`;
    }
    return null;
};

const getBlankContactListItem = (): IContactListItem  => {
  return {
    market: '',
    countryName: '',
    countryLanguage: '',
    showMarketInOptions: '',
    redirectToMarketOrMessage: '',
    localInfo: '',
    localName: '',
    localEmail: '',
    localPhone: '',
    localAddress: '',
    otherInfo: '',
    otherName: '',
    otherEmail: '',
    otherPhone: '',
    otherAddress: '',
    otherWebsiteName: '',
    otherWebsiteUrl: '',
    dropdownIntroduction: '',
    dropdownError: '',
    dropdownLabel: ''
  }
};
 
export const useContactList = () => {
  const contactListStore = useContactListStore();
  const initialMarket = getInitialCurrentMarket() ?? '';
  const currentMarket = ref<string>(initialMarket);

  const getActiveContactList = computed(() => {
    const foundMarket = contactListStore.getContactListItems.filter((contactListItem: IContactListItem) => contactListItem.market === currentMarket.value);
    return foundMarket.length > 0 ? foundMarket[0] : getBlankContactListItem();
  });

  const activeContactListIsOption = computed(() => {
    return getActiveContactList.value.showMarketInOptions === 'true';
  });

  const activeContactListIsRedirect = computed(() => {
    return getActiveContactList.value.redirectToMarketOrMessage !== '';
  });

  const getRedirectMarket = computed(() => {
    return getActiveContactList.value.redirectToMarketOrMessage;
  })

  const getContactListOptions = computed(() => { 
    const currentList =  contactListStore.getContactListItems
      .filter((contactListItem: IContactListItem) => contactListItem.showMarketInOptions === 'true');

      const finalContactListOptions = !activeContactListIsOption.value ? [...currentList, getActiveContactList.value] : currentList;

      return finalContactListOptions.map((contactListItem: IContactListItem) => ({
        label: `${contactListItem.countryName} - ${contactListItem.countryLanguage}`,
        value: contactListItem.market
      }));
  });

  const getContactListToShow = computed(() => {
    if (activeContactListIsRedirect.value) {
      const contactListToShow = contactListStore.getContactListItems
        .filter((contactListItem: IContactListItem) => contactListItem.market === getRedirectMarket.value);
      return contactListToShow.length > 0 ? contactListToShow[0] : getActiveContactList.value;
    }
    return getActiveContactList.value;
  });

  const showLocalSection = computed(() => {
    return (
      !!getContactListToShow.value.localInfo ||
      !!getContactListToShow.value.localName ||
      !!getContactListToShow.value.localEmail ||
      !!getContactListToShow.value.localPhone ||
      !!getContactListToShow.value.localAddress
    );
  });

  const showOtherSection = computed(() => {
    return (
      !!getContactListToShow.value.otherInfo ||
      !!getContactListToShow.value.otherName ||
      !!getContactListToShow.value.otherEmail ||
      !!getContactListToShow.value.otherPhone ||
      !!getContactListToShow.value.otherAddress ||
      !!getContactListToShow.value.otherWebsiteUrl
    );
  });

  const showOtherWebsite = computed(() => {
    return (
      !!getContactListToShow.value.otherWebsiteName &&
      !!getContactListToShow.value.otherWebsiteUrl
    );
  });

  return {
    currentMarket,
    getContactListOptions,
    getContactListToShow,
    showLocalSection,
    showOtherSection,
    showOtherWebsite
  };
}
